import {
  CatchBoundary,
  createRootRouteWithContext,
  Outlet
} from '@tanstack/react-router'
import React, { Suspense } from 'react'
import type { UserInfosResponse } from '~/api/queries/user'
import { TooltipProvider } from '~/components/Global/Elements/Tooltip/TooltipProvider'
import { GlobalError } from '~/components/Global/GlobalError'
import { ToastStack } from '~/components/Global/Interactions/Toast/ToastStack'

interface RouterContext {
  currentUser?: UserInfosResponse | null
}

const TanStackRouterDevtools =
  process.env.NODE_ENV === 'production'
    ? () => null
    : React.lazy(() =>
        import('@tanstack/react-router-devtools').then((res) => ({
          default: res.TanStackRouterDevtools
        }))
      )

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootComponent
})

function RootComponent(): React.ReactElement {
  return (
    <>
      <CatchBoundary errorComponent={GlobalError} getResetKey={() => 'reset'}>
        <TooltipProvider>
          <Outlet />
          <ToastStack />
        </TooltipProvider>
      </CatchBoundary>
      <Suspense>
        <TanStackRouterDevtools />
      </Suspense>
    </>
  )
}
